import angular from 'angular';
import components from './components';

export default angular.module('mergeContact.scenes.duplicateContactsModal', [
  components,
]).name;
